import React from 'react';
import './styles/App.css';
import {Navigate, Route, Routes} from "react-router";
import RootLayout from "./layouts/RootLayout";
import Login from "./pages/Login";
import PrivateLayout from "./layouts/PrivateLayout";
import PrivateOrders from "./pages/Private/Orders";
import Profile from "./pages/Private/Profile";
import Reports from "./pages/Private/Reports";
import Comments from "./pages/Private/Comments";
import PrivateOrder from "./pages/Private/PrivateOrder";
import FinancialTransactions from "./pages/Private/FinancialTransactions"
import ProductsMenu from "./pages/Private/ProductsMenu"
import PrivateProductsMenu from "./pages/Private/PrivateProductsMenu";
import Off from "./pages/Private/Off";

const App = () => {
    return (
        <>
            <Routes>
                <Route element={<RootLayout/>}>
                    <Route index element={<Navigate to="orders" replace/>}/>
                    <Route path="login" element={<Login/>}/>
                    <Route element={<PrivateLayout/>}>
                        <Route path="profile" element={<Profile/>}/>
                        <Route path="orders" element={<PrivateOrders/>}/>
                        <Route path="orders/:id" element={<PrivateOrder/>}/>
                        <Route path="reports" element={<Reports/>}/>
                        <Route path="comments" element={<Comments/>}/>
                        <Route path="off" element={<Off/>}/>
                        <Route path="financial-transactions" element={<FinancialTransactions/>}/>
                        <Route path="products-menu" element={<ProductsMenu/>}/>
                        <Route path="products-menu/:id" element={<PrivateProductsMenu/>}/>
                    </Route>
                </Route>
            </Routes>
        </>
    );
};

export default App;